import React from 'react';
import Email from '@mui/icons-material/Email';
import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';
import Logo from './images/logo.png';

const StyledImage = styled('img')(({ theme }) => ({
  width: '25vw',
  maxWidth: '330px',
  minWidth: '130px',
}));

const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.black,
  lineHeight: '1.5',
  fontWeight: '700',
  fontSize: '20px',
  fontFamily: 'ZalandoSans',
  display: 'flex',
  alignItems: 'center',
}));

const PatentText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  lineHeight: '1.5',
  fontWeight: '400',
  fontSize: '14px',
  fontFamily: 'ZalandoSans',
  display: 'flex',
  alignItems: 'center',
}));

export default function AboutSection() {
  return (
    <Box sx={{ p: '0!important' }}>
      <Box
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: { lg: '0', xs: '32px' },
          flexDirection: { md: 'row', xs: 'column' },
          height: { md: 200, xs: 'auto' },
        }}
      >
        <StyledImage src={Logo} alt="Logo" />
        <Box
          sx={{
            display: 'flex',
            alignItems: { md: 'end', xs: 'center' },
            flexDirection: 'column',
            gap: 1,
            mt: { md: 0, xs: 4 },
          }}
        >
          <StyledText sx={{ mr: 2 }}>
            <Email sx={{ fontSize: '25px', mr: 1.5, color: 'error.main' }} />
            james.mcglothlin@videoplussensors.com
          </StyledText>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: { md: 'end', xs: 'center' },
          flexDirection: 'column',
          gap: 1,
          mt: { md: 0, xs: 2 },
          pb: 2,
          mx: { xl: '0', xs: '32px' },
        }}
      >
        <PatentText>&copy; 2026 Video Plus Sensors, Inc. All rights reserved</PatentText>
        <PatentText>
          Trademark VPSi&trade; and Video Plus Sensors, Inc.&trade; are trademarks of Video Plus Sensors, Inc.
        </PatentText>
        <PatentText>VPSi technology is protected by U.S. Patent filing. Additional patents pending</PatentText>
      </Box>
    </Box>
  );
}
